<nb-menu [items]="menuItems" [autoCollapse]="true" #sideBar kwHorizontalExpand (toggleSubMenu)="onToggleSubMenu($event)"></nb-menu>
<!-- <div [ngClass]="secondaryMenuItems.length > 0 ? 'display-secondary': 'hide-secondary'">
    <nb-menu [items]="secondaryMenuItems" [autoCollapse]="true"></nb-menu>
</div>  -->   
